export const SWITCH_ORGANIZATION = 'app/OrganizationSelector/SWITCH_ORGANIZATION';
export const SWITCH_ORGANIZATION_SUCCESS = 'app/OrganizationSelector/SWITCH_ORGANIZATION_SUCCESS';
export const SWITCH_ORGANIZATION_FAILED = 'app/OrganizationSelector/SWITCH_ORGANIZATION_FAILED';
export const RELOAD = 'app/OrganizationSelector/RELOAD';
